import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { DistributorComponent } from './components/admin/distributor/distributor.component';

export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        component: DistributorComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('./components/admin/admin.routes').then(m => m.adminRoutes), data: { animation: 'admin' },
      },
    ],
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
  },  
  { path: '**', redirectTo: 'admin/distributor' },
];
